/**
 * Formats a price for display: two decimals, French comma.
 *
 * Accepts a string because the API returns one for `crossed_price` —
 * `"17.99"`, or `""` when there's no crossed-out price. The three cards used
 * to call a local `formatPrice(price: number)` with this string, which would
 * have thrown a TypeError the day that branch renders: strings don't have
 * `toFixed`.
 */
export function formatPrice(price: number | string): string {
  const value = typeof price === 'number' ? price : parseFloat(price);
  return Number.isFinite(value) ? value.toFixed(2).replace('.', ',') : '';
}
